module.exports = __webpack_public_path__ + "img/1.ca701b6.jpg";